// Rivae — scripts propios (vanilla, sin dependencias)
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContador();
  initMarquesina();
  initGaleriaProducto();
  initVariantes();
  initFaq();
  initComparadorAuto();
  initParallax();
  initBarraFija();
  initEjerciciosCarrusel();
  initPasosFijos();
  initValoracionReal();
  initCopiarCodigoPromo();
  initSelectorCantidad();
});

function rvFormatearPrecio(centavos) {
  return (centavos / 100).toFixed(2).replace('.', ',') + ' €';
}

function initSelectorCantidad() {
  var grupo = document.querySelector('[data-rv-cantidad-grupo]');
  var precioEl = document.querySelector('[data-rv-precio]');
  var cantidadInput = document.querySelector('[data-rv-cantidad-input]');
  if (!grupo || !precioEl) return;
  var tiles = grupo.querySelectorAll('[data-rv-cantidad-tile]');
  var cantidadActual = 1;
  var descuentoFijoActual = 0;

  function precioUnitarioActual() {
    return parseInt(precioEl.getAttribute('data-rv-precio-raw'), 10) || 0;
  }

  function pintarTiles() {
    var unitario = precioUnitarioActual();
    tiles.forEach(function (tile) {
      var cantidad = parseInt(tile.getAttribute('data-rv-cantidad'), 10);
      var descuentoFijo = parseInt(tile.getAttribute('data-rv-cantidad-descuento-fijo'), 10) || 0;
      var total = (unitario * cantidad) - descuentoFijo;
      var precioTile = tile.querySelector('[data-rv-cantidad-precio]');
      if (precioTile) precioTile.textContent = rvFormatearPrecio(total);
    });
  }

  function actualizarPrecioPrincipal() {
    var unitario = precioUnitarioActual();
    var total = (unitario * cantidadActual) - descuentoFijoActual;
    precioEl.textContent = rvFormatearPrecio(total);
  }

  tiles.forEach(function (tile) {
    tile.addEventListener('click', function () {
      tiles.forEach(function (t) { t.classList.remove('rv-producto__cantidad-tile--activa'); });
      tile.classList.add('rv-producto__cantidad-tile--activa');
      cantidadActual = parseInt(tile.getAttribute('data-rv-cantidad'), 10) || 1;
      descuentoFijoActual = parseInt(tile.getAttribute('data-rv-cantidad-descuento-fijo'), 10) || 0;
      if (cantidadInput) cantidadInput.value = cantidadActual;
      actualizarPrecioPrincipal();
    });
  });

  document.addEventListener('rv:variante-cambiada', function () {
    pintarTiles();
    actualizarPrecioPrincipal();
  });

  pintarTiles();
  actualizarPrecioPrincipal();
}

function initCopiarCodigoPromo() {
  var boton = document.querySelector('[data-rv-copiar-codigo]');
  var codigoEl = document.querySelector('[data-rv-promo-codigo]');
  if (!boton || !codigoEl) return;
  boton.addEventListener('click', function () {
    var codigo = codigoEl.textContent.trim();
    var marcarCopiado = function () {
      boton.classList.add('rv-copiado');
      setTimeout(function () { boton.classList.remove('rv-copiado'); }, 1500);
    };
    var copiarConTextarea = function () {
      var temp = document.createElement('textarea');
      temp.value = codigo;
      temp.style.position = 'fixed';
      temp.style.opacity = '0';
      document.body.appendChild(temp);
      temp.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(temp);
      marcarCopiado();
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(codigo).then(marcarCopiado).catch(copiarConTextarea);
    } else {
      copiarConTextarea();
    }
  });
}

function initValoracionReal() {
  // El widget de Judge.me carga de forma asíncrona y, tras montarse, hace su
  // propia petición para pintar el promedio y el número de reseñas reales
  // en su cabecera — el atributo data-* del contenedor se queda con la foto
  // cacheada del primer render y NO se actualiza, así que leemos el texto
  // que el propio widget termina mostrando, no ese atributo.
  var enlace = document.querySelector('[data-rv-valoracion]');
  if (!enlace) return;
  var textoEl = enlace.querySelector('[data-rv-valoracion-texto]');
  var estrellasEl = enlace.querySelector('[data-rv-valoracion-estrellas]');
  var intentos = 0;
  var maxIntentos = 60; // ~30s a 500ms
  var id = setInterval(function () {
    intentos++;
    var cabecera = document.querySelector('.jm-average-rating-display--minimal-header');
    var partes = cabecera ? cabecera.querySelectorAll('p.jm-text') : null;
    if (partes && partes.length >= 2) {
      var mediaNum = parseFloat(partes[0].textContent.trim().replace(',', '.'));
      var conteoMatch = partes[1].textContent.trim().match(/\d+/);
      var conteo = conteoMatch ? conteoMatch[0] : null;
      if (!isNaN(mediaNum) && conteo) {
        if (textoEl) textoEl.textContent = mediaNum.toFixed(1) + ' · ' + conteo + ' opiniones';
        if (estrellasEl) {
          var estrellas = estrellasEl.querySelectorAll('svg');
          estrellas.forEach(function (svg, i) {
            svg.setAttribute('fill', (i + 1) <= Math.round(mediaNum) ? 'currentColor' : 'none');
          });
        }
        clearInterval(id);
      }
    }
    if (intentos >= maxIntentos) clearInterval(id);
  }, 500);
}

function initPasosFijos() {
  var visual = document.querySelector('[data-rv-pasos-visual]');
  var pasos = document.querySelectorAll('[data-rv-paso-item]');
  if (!visual || !pasos.length) return;
  var imgs = visual.querySelectorAll('.rv-pasos__visual-img');
  var mq = window.matchMedia('(min-width: 990px)');
  var activo = 0;
  function actualizar() {
    if (!mq.matches) return;
    var centro = window.innerHeight / 2;
    var mejor = 0;
    var mejorDist = Infinity;
    pasos.forEach(function (paso, i) {
      var r = paso.getBoundingClientRect();
      var dist = Math.abs((r.top + r.height / 2) - centro);
      if (dist < mejorDist) { mejorDist = dist; mejor = i; }
    });
    if (mejor !== activo || !imgs[activo].classList.contains('rv-pasos__visual-img--activa')) {
      activo = mejor;
      imgs.forEach(function (img, i) {
        img.classList.toggle('rv-pasos__visual-img--activa', i === activo);
      });
    }
  }
  // No depende solo de requestAnimationFrame (puede quedar en pausa si la
  // pestaña no está pintando en primer plano) — añade un intervalo de red de
  // seguridad, igual que initBarraFija/rvVigilar.
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { actualizar(); ticking = false; });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  setInterval(actualizar, 400);
  actualizar();
}

function initEjerciciosCarrusel() {
  var botones = document.querySelectorAll('[data-rv-ejercicio-toggle]');
  botones.forEach(function (boton) {
    boton.addEventListener('click', function (e) {
      e.preventDefault();
      var tarjeta = boton.closest('.rv-ejercicios__tarjeta');
      if (!tarjeta) return;
      var abierta = tarjeta.classList.contains('rv-ejercicios__tarjeta--abierta');
      document.querySelectorAll('.rv-ejercicios__tarjeta--abierta').forEach(function (t) {
        if (t !== tarjeta) {
          t.classList.remove('rv-ejercicios__tarjeta--abierta');
          var otroBoton = t.querySelector('[data-rv-ejercicio-toggle]');
          if (otroBoton) otroBoton.setAttribute('aria-expanded', 'false');
        }
      });
      tarjeta.classList.toggle('rv-ejercicios__tarjeta--abierta', !abierta);
      boton.setAttribute('aria-expanded', String(!abierta));
    });
  });
}

function initBarraFija() {
  // No depende de requestAnimationFrame (puede quedar en pausa si la pestaña
  // no está pintando en primer plano) — usa scroll/resize + un intervalo de
  // red de seguridad, igual que rvVigilar.
  var barra = document.querySelector('[data-rv-barra-fija]');
  var botonPrincipal = document.querySelector('[data-rv-boton-comprar]');
  if (!barra || !botonPrincipal) return;
  var botonFijo = barra.querySelector('[data-rv-boton-fijo]');
  function actualizar() {
    var pasado = botonPrincipal.getBoundingClientRect().bottom < 0;
    barra.classList.toggle('rv-visible', pasado);
  }
  window.addEventListener('scroll', actualizar, { passive: true });
  window.addEventListener('resize', actualizar);
  setInterval(actualizar, 500);
  actualizar();
  if (botonFijo) {
    botonFijo.addEventListener('click', function () { botonPrincipal.click(); });
  }
}

function initParallax() {
  var els = document.querySelectorAll('[data-rv-parallax]');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var ticking = false;
  function actualizar() {
    els.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      var centro = rect.top + rect.height / 2 - window.innerHeight / 2;
      var intensidad = parseFloat(el.getAttribute('data-rv-parallax')) || 0.06;
      el.style.transform = 'translateY(' + (centro * intensidad * -1) + 'px)';
    });
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { requestAnimationFrame(actualizar); ticking = true; }
  }, { passive: true });
  actualizar();
}

function initComparadorAuto() {
  document.querySelectorAll('[data-rv-comparador-auto]').forEach(function (wrap) {
    var marco = wrap.querySelector('.rv-comparador__marco');
    var clip = wrap.querySelector('[data-rv-comparador-clip]');
    var linea = wrap.querySelector('[data-rv-comparador-linea]');
    if (!marco || !clip) return;
    var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function actualizar() {
      var r = marco.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      // Recorrido completo: 0 cuando el marco empieza a entrar por abajo,
      // 1 cuando ha salido del todo por arriba. Con "esperas" al principio y
      // al final para que se vea bien "antes" y bien "después", y el cruce
      // ocurra solo en el tramo central del scroll.
      var bruto = (vh - r.top) / (vh + r.height);
      bruto = Math.max(0, Math.min(1, bruto));
      var progreso = (bruto - 0.2) / 0.6;
      progreso = Math.max(0, Math.min(1, progreso));
      if (reducido) progreso = 1;
      var pct = Math.round(progreso * 100);
      clip.style.clipPath = 'inset(0 ' + pct + '% 0 0)';
      if (linea) linea.style.left = pct + '%';
    }
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { actualizar(); ticking = false; });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    // Red de seguridad: igual que initPasosFijos/initBarraFija, por si el
    // scroll/rAF no dispara de forma fiable en algún entorno.
    setInterval(actualizar, 400);
    actualizar();
  });
}

// Comprueba visibilidad "a mano" (además de IntersectionObserver) porque en
// algunos navegadores/entornos el observer no dispara de forma fiable y el
// contenido con opacidad 0 quedaba invisible para siempre. Nunca debe quedar
// contenido oculto permanentemente.
function rvEnViewport(el, margen) {
  var r = el.getBoundingClientRect();
  var alto = window.innerHeight || document.documentElement.clientHeight;
  return r.top < alto - (margen || 0) && r.bottom > 0;
}

function rvVigilar(elementos, alcanzado) {
  var pendientes = Array.prototype.slice.call(elementos);
  function revisar() {
    pendientes = pendientes.filter(function (el) {
      if (rvEnViewport(el, 60)) { alcanzado(el); return false; }
      return true;
    });
    if (!pendientes.length) {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      clearInterval(intervalo);
    }
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { revisar(); ticking = false; });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  // Red de seguridad: por si el scroll/observer no dispara en algún entorno.
  var intervalo = setInterval(revisar, 700);
  revisar();
}

function initReveal() {
  var els = document.querySelectorAll('.rv-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('rv-visible'); });
    return;
  }
  rvVigilar(els, function (el) { el.classList.add('rv-visible'); });
}

function initContador() {
  // Cuenta con setInterval (no requestAnimationFrame): rAF puede quedar en
  // pausa si la pestaña no está pintando en primer plano, y el número se
  // quedaría congelado en 0 para siempre. setInterval sigue disparando.
  var els = document.querySelectorAll('[data-rv-contador]');
  if (!els.length) return;
  rvVigilar(els, function (el) {
    var fin = parseFloat(el.getAttribute('data-rv-contador')) || 0;
    var pasos = 24;
    var dur = 1200;
    var paso = 0;
    var id = setInterval(function () {
      paso++;
      var p = Math.min(paso / pasos, 1);
      var val = fin * (1 - Math.pow(1 - p, 3));
      el.textContent = (fin % 1 === 0 ? Math.round(val) : val.toFixed(1)).toString();
      if (p >= 1) {
        el.textContent = fin % 1 === 0 ? fin : fin.toFixed(1);
        clearInterval(id);
      }
    }, dur / pasos);
  });
}

function initMarquesina() {
  document.querySelectorAll('.rv-marquesina').forEach(function (wrap) {
    var track = wrap.querySelector('.rv-marquesina__track');
    if (!track || track.dataset.rvCloned) return;
    track.dataset.rvCloned = '1';
    track.innerHTML += track.innerHTML;
  });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-rv-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-rv-imagen-principal]');
  var minis = galeria.querySelectorAll('[data-rv-mini]');
  if (!principal || !minis.length) return;
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var src = mini.getAttribute('data-rv-src');
      var srcset = mini.getAttribute('data-rv-srcset');
      if (!src) return;
      principal.src = src;
      if (srcset) principal.srcset = srcset;
      minis.forEach(function (m) { m.classList.remove('rv-mini--activa'); });
      mini.classList.add('rv-mini--activa');
    });
  });
}

function initVariantes() {
  var form = document.querySelector('[data-rv-form-producto]');
  if (!form) return;
  var datosEl = document.querySelector('[data-rv-variantes-json]');
  if (!datosEl) return;
  var variantes;
  try { variantes = JSON.parse(datosEl.textContent); } catch (e) { return; }

  var grupos = form.querySelectorAll('[data-rv-opcion-grupo]');
  var inputId = form.querySelector('input[name="id"]');
  var precioEl = document.querySelector('[data-rv-precio]');
  var precioCompareEl = document.querySelector('[data-rv-precio-comparado]');
  var botonComprar = form.querySelector('[data-rv-boton-comprar]');
  var botonComprarAhora = form.querySelector('[data-rv-boton-comprar-ahora]');
  var imagenPrincipal = document.querySelector('[data-rv-imagen-principal]');
  var minis = document.querySelectorAll('[data-rv-mini]');

  if (botonComprarAhora) {
    botonComprarAhora.addEventListener('click', function () {
      if (botonComprarAhora.disabled || !inputId || !inputId.value) return;
      var textoOriginal = botonComprarAhora.textContent;
      botonComprarAhora.disabled = true;
      botonComprarAhora.textContent = 'Redirigiendo…';
      var cantidadInput = form.querySelector('[data-rv-cantidad-input]');
      var cantidad = cantidadInput ? parseInt(cantidadInput.value, 10) || 1 : 1;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: inputId.value, quantity: cantidad })
      }).then(function (r) {
        if (!r.ok) throw new Error('No se pudo añadir al carrito');
        window.location.href = '/checkout';
      }).catch(function () {
        botonComprarAhora.disabled = false;
        botonComprarAhora.textContent = textoOriginal;
        window.location.href = '/cart';
      });
    });
  }

  var RV_COLORES = {
    'negro': '#332821', 'onyx': '#332821',
    'rosa': '#D9A6AC', 'blush': '#D9A6AC',
    'azul': '#AFC9DE', 'sky': '#AFC9DE',
    'verde': '#B7C9AE', 'sage': '#B7C9AE',
    'morado': '#B29BC2', 'violet': '#B29BC2'
  };

  function claseActiva(grupo) {
    return 'rv-producto__' + grupo.getAttribute('data-rv-opcion-tipo') + '--activa';
  }

  function valorDeGrupo(grupo) {
    var select = grupo.querySelector('select[data-rv-opcion]');
    if (select) return select.value;
    var activo = grupo.querySelector('.' + claseActiva(grupo));
    if (activo) return activo.getAttribute('data-valor');
    var primero = grupo.querySelector('[data-rv-opcion]');
    return primero ? primero.getAttribute('data-valor') : null;
  }

  function fijarValorGrupo(grupo, valor) {
    var select = grupo.querySelector('select[data-rv-opcion]');
    if (select) { select.value = valor; return; }
    var clase = claseActiva(grupo);
    grupo.querySelectorAll('[data-rv-opcion]').forEach(function (btn) {
      btn.classList.toggle(clase, btn.getAttribute('data-valor') === valor);
    });
    var etiqueta = grupo.querySelector('[data-rv-color-actual]');
    if (etiqueta) etiqueta.textContent = valor;
  }

  // Pinta las muestras de color según su nombre.
  grupos.forEach(function (grupo) {
    if (grupo.getAttribute('data-rv-opcion-tipo') !== 'color') return;
    grupo.querySelectorAll('[data-rv-color-nombre]').forEach(function (btn) {
      var nombre = (btn.getAttribute('data-rv-color-nombre') || '').toLowerCase();
      btn.style.background = RV_COLORES[nombre] || '#ccc';
    });
  });

  function variantePorOpciones(valores) {
    return variantes.find(function (v) {
      return v.opciones.every(function (op, i) { return op === valores[i]; });
    });
  }

  // Si hay un grupo "version" y otro "color", el color se filtra según la
  // versión elegida (no todos los colores existen en todas las versiones).
  function filtrarColoresPorVersion() {
    var grupoVersion = null, grupoColor = null;
    grupos.forEach(function (g) {
      if (g.getAttribute('data-rv-opcion-tipo') === 'version') grupoVersion = g;
      if (g.getAttribute('data-rv-opcion-tipo') === 'color') grupoColor = g;
    });
    if (!grupoVersion || !grupoColor) return;
    var version = valorDeGrupo(grupoVersion);
    var validos = variantes.filter(function (v) { return v.opciones[0] === version; })
      .map(function (v) { return v.opciones[1]; });
    var colorActual = valorDeGrupo(grupoColor);
    var colorSigueValido = validos.indexOf(colorActual) > -1;
    grupoColor.querySelectorAll('[data-rv-opcion]').forEach(function (btn) {
      var vale = validos.indexOf(btn.getAttribute('data-valor')) > -1;
      btn.classList.toggle('rv-producto__color--deshabilitada', !vale);
    });
    if (!colorSigueValido && validos.length) {
      fijarValorGrupo(grupoColor, validos[0]);
    }
  }

  function actualizar() {
    filtrarColoresPorVersion();
    var valores = Array.prototype.map.call(grupos, valorDeGrupo);
    var v = variantePorOpciones(valores);
    if (!v) return;
    inputId.value = v.id;
    if (precioEl) {
      precioEl.textContent = v.precio;
      precioEl.setAttribute('data-rv-precio-raw', v.precioRaw);
      document.dispatchEvent(new CustomEvent('rv:variante-cambiada', { detail: { precioRaw: v.precioRaw } }));
    }
    if (precioCompareEl) {
      if (v.precioComparado) { precioCompareEl.textContent = v.precioComparado; precioCompareEl.style.display = ''; }
      else { precioCompareEl.style.display = 'none'; }
    }
    if (botonComprar) {
      botonComprar.disabled = !v.disponible;
      botonComprar.textContent = v.disponible ? botonComprar.getAttribute('data-rv-texto-comprar') : botonComprar.getAttribute('data-rv-texto-agotado');
    }
    if (v.imagen && imagenPrincipal) {
      imagenPrincipal.src = v.imagen;
      imagenPrincipal.alt = v.imagenAlt || imagenPrincipal.alt;
      minis.forEach(function (m) {
        var esta = m.getAttribute('data-rv-src') === v.imagen;
        m.classList.toggle('rv-mini--activa', esta);
      });
    }
  }

  grupos.forEach(function (grupo) {
    var select = grupo.querySelector('select[data-rv-opcion]');
    if (select) { select.addEventListener('change', actualizar); return; }
    grupo.querySelectorAll('button[data-rv-opcion]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('rv-producto__color--deshabilitada')) return;
        fijarValorGrupo(grupo, btn.getAttribute('data-valor'));
        actualizar();
      });
    });
  });
  actualizar();
}

function initFaq() {
  document.querySelectorAll('[data-rv-faq-item]').forEach(function (item) {
    var pregunta = item.querySelector('[data-rv-faq-pregunta]');
    if (!pregunta) return;
    pregunta.addEventListener('click', function () {
      var abierta = item.classList.contains('rv-faq__item--abierta');
      item.closest('[data-rv-faq]').querySelectorAll('[data-rv-faq-item]').forEach(function (i) {
        i.classList.remove('rv-faq__item--abierta');
      });
      if (!abierta) item.classList.add('rv-faq__item--abierta');
    });
  });
}
